import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Nav, Navbar, Container } from 'react-bootstrap';
import axios from 'axios';

import { useAuthState } from '../../services/auth';

const appNames = ['dde', 'mongo', 'mqtt', 'redis'];

export const NOCAnalyst = ({ children }: any) => {
    const { token } = useAuthState();
    const location = useLocation();
    const isNOC = location.pathname.includes('noc-analyst');
    //const [serviceStatus, setServiceStatus] = useState<any>()

    /*  async function fetchServiceStatus() {
         const data2 = await axios.get('/op/services-status');
         setServiceStatus(data2?.data)
     }
 
     useEffect(() => {
         if (token) {
             fetchServiceStatus();
         }
     }, [token]); */
    return (
        isNOC ?
            (<section id="home">
                <div className="container-fluid">
                    {children}
                </div>

            </section>)
            :
            <></>
    )
}
